export const galliumPricesMock = {
    6261: {
        price: 89.99,
        promoPrice: 0,
        refund: -89.99,
        refundsList: [
            { untilDate: 0, name: 'Remise Forfait -17,09 euros', promoLabel: '', amount: -17.09 },
            { untilDate: 0, name: 'Remise Forfait Collaborateur', promoLabel: '', amount: -72.9 },
        ],
        refundsWithDate: 0,
    },
    6468: { price: 48.99 },
    6469: { price: 27.99 },
    6480: { price: 12.99 },
    6481: {
        price: 41.99,
        promoPrice: 11.99,
        refund: -30,
        refundsList: [
            {
                untilDate: 0,
                duration: 12,
                promoLabel: 'pendant 12 mois',
                name: 'Remise Fantasy 1',
                amount: -20,
            },
            {
                untilDate: 0,
                duration: 12,
                promoLabel: 'pendant 12 mois',
                name: 'Remise Fantasy 2',
                amount: -10,
            },
        ],
        refundsWithDate: 0,
    },
    6482: {
        price: 69.99,
        promoPrice: 0,
        refund: -69.99,
        refundsList: [
            {
                untilDate: 0,
                name: 'Remise Forfait Collaborateur',
                amount: -69.99,
                promoLabel: '',
            },
        ],
        refundsWithDate: 0,
    },
    6492: { price: 7.99 },
    6498: { price: 32.99 },
    6499: { price: 143.99 },
    6504: { price: 46.79 },
    6505: {
        price: 53.99,
        promoPrice: 18.99,
        refund: -35,
        refundsList: [
            {
                untilDate: 0,
                duration: 12,
                promoLabel: 'pendant 12 mois',
                name: 'Remise Fantasy 1',
                amount: -20,
            },
            {
                untilDate: 0,
                duration: 12,
                promoLabel: 'pendant 12 mois',
                name: 'Remise Fantasy 2',
                amount: -10,
            },
            {
                untilDate: 0,
                name: 'Remise Forfait Collaborateur',
                amount: -5,
                promoLabel: '',
            },
        ],
        refundsWithDate: 0,
    },
    6506: { price: 74.99 },
};
